/**
 * The presets' ids, apart from the presets themselves, so the route can check
 * a URL's preset without loading the playground's cards when the app starts
 */
export const PLAYGROUND_PRESET_IDS = [
  'assist-off',
  'empty',
  'answers',
  'follow-ups',
  'answers-and-follow-ups',
  'follow-ups-open',
  'all-done',
  'running-and-failed',
  'popup',
  'revealed-card',
  'long-content',
  'many-cards',
] as const;

export type PlaygroundPresetId = (typeof PLAYGROUND_PRESET_IDS)[number];

export const DEFAULT_PRESET_ID: PlaygroundPresetId = 'answers-and-follow-ups';
